var _rect, _rect2, _rect3, _polygon, _polygon2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyriaNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 100",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 100,
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 33.333,
    y: 0,
    fill: "#007a3d"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 33.333,
    y: 66.667,
    fill: "#000000"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d21034",
    points: "40,42 42.35,47.4 48,47.8 43.8,51.6 45,57 40,54 35,57 36.2,51.6 32,47.8 37.65,47.4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d21034",
    points: "80,42 82.35,47.4 88,47.8 83.8,51.6 85,57 80,54 75,57 76.2,51.6 72,47.8 77.65,47.4"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d21034",
    points: "120,42 122.35,47.4 128,47.8 123.8,51.6 125,57 120,54 115,57 116.2,51.6 112,47.8 117.65,47.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyriaNew);
export default __webpack_public_path__ + "static/media/syria-new.1ae303edf44712625be2ae9d1453cee6.svg";
export { ForwardRef as ReactComponent };